import React, { Suspense, lazy } from 'react';
import { useTranslation } from 'react-i18next';
import CurrentMonthWidget from './widgets/CurrentMonthWidget';

const EmissionWidget = lazy(() => import('./widgets/EmissionWidget'));
const ReportsWidget = lazy(() => import('./widgets/ReportsWidget'));

function Dashboard() {
  const { t } = useTranslation();

  return (
    <div>
      

      {/* Page Header */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900">{t('dashboard.title')}</h1>
        <p className="text-gray-600 mt-2">{t('dashboard.description')}</p>
      </div>

      {/* Dashboard Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6">
        {/* Main Emission Widget */}
        <div className="lg:col-span-2">
          <Suspense fallback={(
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 h-full">
              <div className="h-6 w-40 bg-gray-200 rounded animate-pulse mb-6"></div>
              <div className="h-8 w-64 bg-gray-200 rounded animate-pulse mb-6"></div>
              <div className="h-64 w-full bg-gray-100 rounded animate-pulse" />
            </div>
          )}>
            <EmissionWidget />
          </Suspense>
        </div>
        
        {/* Current Month Widget */}
        <div className="lg:col-span-1">
          <CurrentMonthWidget />
        </div>
      </div>

      {/* Reports Widget */}
      <div>
        <Suspense fallback={(
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between mb-6">
              <div className="h-6 w-48 bg-gray-200 rounded animate-pulse"></div>
              <div className="h-5 w-20 bg-gray-200 rounded animate-pulse"></div>
            </div>
            <div className="h-16 w-full bg-gray-100 rounded animate-pulse mb-4"></div>
            <div className="space-y-3">
              <div className="h-14 w-full bg-gray-50 border border-gray-200 rounded animate-pulse"></div>
              <div className="h-14 w-full bg-gray-50 border border-gray-200 rounded animate-pulse"></div>
              <div className="h-14 w-full bg-gray-50 border border-gray-200 rounded animate-pulse"></div>
            </div>
          </div>
        )}>
          <ReportsWidget />
        </Suspense>
      </div>
    </div>
  );
}

export default Dashboard; 